import { render, staticRenderFns } from "./Testimonialspopup1.vue?vue&type=template&id=0e7f1b2e"
import script from "./Testimonialspopup1.vue?vue&type=script&lang=js"
export * from "./Testimonialspopup1.vue?vue&type=script&lang=js"
import style0 from "./Testimonialspopup1.vue?vue&type=style&index=0&id=0e7f1b2e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports